__turbopack_context__.v({
  "desktop": "CreateWallet-module__35mXPq__desktop",
  "root": "CreateWallet-module__35mXPq__root",
});
